import _export from '../internals/export.js';
import descriptors from '../internals/descriptors.js';
import '../internals/object-define-properties.js';
import { __exports as objectDefineProperties } from '../../../../../../_virtual/object-define-properties.js';

var $ = _export;
var DESCRIPTORS = descriptors;
var defineProperties = objectDefineProperties.f; // `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe

$({
  target: 'Object',
  stat: true,
  forced: Object.defineProperties !== defineProperties,
  sham: !DESCRIPTORS
}, {
  defineProperties: defineProperties
});
